import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Connector } from 'mqtt-react';
import { debounce } from 'lodash';
import mqtt from 'mqtt';

import Loading from '../Loading/Loading';
import { EnumAppType, EnumClientType } from '../../constants/enum';
import { exchangeRawAccessToken } from '../../authentication/actions';

export function withMqtt(WrappedComponent) {
  class WithMqtt extends React.PureComponent {
    constructor(props) {
      super(props);

      this.state = {
        mqttConnected: false,
        mqttClient: null,
      };
    }

    componentDidMount() {
      const { auth } = this.props;
      const { authenticated } = auth;
      if (authenticated) {
        this.connectMqtt();
      }
    }

    createMqttUsername = () => {
      const {
        auth: { user },
      } = this.props;
      const { uid, foodyUid, username } = user;
      return `uid=${uid}&foody_uid=${foodyUid}&username=${username}&app_type=${
        EnumAppType.NOW_MERCHANT_APP
      }`;
    };

    createMqttPassword = () => {
      const {
        auth: { token },
      } = this.props;
      return `access_token=${token}&client_type=${
        EnumClientType.CLIENT_WEB
      }&client_version=${
        CONFIG.CLIENT_VERSION.API
      }&client_id=&client_language=vn`;
    };

    connectMqtt = () => {
      const clientId = `mqttjs_${Math.random()
        .toString(16)
        .substring(2)}`;

      const mThis = this;
      const options = {
        protocol: CONFIG.MQTT_WS,
        host: CONFIG.MQTT_HOST,
        port: CONFIG.MQTT_PORT,
        path: '/mqtt',
        clientId,
        reconnectPeriod: 5000,
        username: this.createMqttUsername(),
        get password() {
          return mThis.createMqttPassword();
        },
      };

      const mqttClient = mqtt.connect(options);

      mqttClient.on('connect', () => {
        this.setState({
          mqttClient,
          mqttConnected: true,
        });
      });

      mqttClient.on(
        'error',
        debounce((error) => {
          console.error(error.toString());
          // This is a hack to know that access token is expired
          if (error.toString().includes('Bad username or password')) {
            const { exchangeRawAccessTokenConnect } = this.props;
            exchangeRawAccessTokenConnect().then(() => {
              mqttClient.reconnect();
            });
          }
        }, 500),
      );
    };

    render() {
      const { mqttClient, mqttConnected } = this.state;
      const { app } = this.props;
      const { isReady } = app;
      if (!isReady) {
        return <Loading loading />;
      }

      return (
        mqttConnected && (
          <Connector mqtt={mqttClient}>
            <WrappedComponent {...this.props} />
          </Connector>
        )
      );
    }
  }

  function mapStateToProp(state) {
    return {
      app: state.app,
      auth: state.auth,
    };
  }

  const mapDispatchToProps = {
    exchangeRawAccessTokenConnect: exchangeRawAccessToken,
  };

  return withRouter(
    connect(
      mapStateToProp,
      mapDispatchToProps,
    )(WithMqtt),
  );
}



// WEBPACK FOOTER //
// ./foody/src/components/HOC/ConnectMqtt.jsx